export const BaseInviteTestIds = {
  baseInvite: 'base_invite',
  vzdSearchbar: 'vzd_searchbar',
  inviteLowerSearchbar: 'invite_lower_searchbar',
  errorMessage: 'error_message',
  verzeichnisChip: 'verzeichnis_chip',
  vzdFieldSearchInput: 'vzd_field_search_input',
  fieldSearchInput: 'field_search_input',
  buttonBack: 'button_back',
  buttonCancel: 'button_cancel',
  buttonInvite: 'button_invite',
  buttonConfirmInvite: 'button_confirm_invite',
  buttonCancelInvite: 'button_cancel_invite',
  vzdTable: 'vzd_table',
  vzdNoresults: 'vzd_noresults',
  searchField: 'field_search',
  noResultsMessage: 'no_results_message'
} as const;
